const color = {
  red: '#F36273',
  blue: '#305FED',
  green: '#2a9c9d',
  black: '#1F1F1F',
  grey: '#8A8A8A',
  white: '##FFFFFF',
  electricBlue: '#003cde',
  royalBlue: '#317df6',
  darkBlue: '#07236d',
  primary002: '#4B88F8',

  success: '#00C767',
  error: '#F95247',
  warning: '#EDAE30',
  action: '#305FED',
  disable: '#DCDCDC',
  backgroundColor: '##F5F5F5',
  border: '#cccccc',
}

const input = {
  color: '#1F1F1F',
  disable: '#F7F8F9',
  border: '#EAEAEA',
  activeBorder: '#1E6AF6',
  activeBorderV2: '#176afc',
}

const color_level = {
  red: {
    high: '#D70004',
    medium: '#ED3034',
    low: '#F55759',
  },

  blue: {
    high: '#134EE4',
    medium: '#305FED',
    low: '#577AF5',
  },

  grey: {
    dark: '#252525',
    high: '#494949',
    medium: '#8A8A8A',
    low: '#BBBBBB',
    light: '#DCDCDC',
  },
}

const media = {
  mobile_xs: '@media screen and (max-width: 350px)',
  mobile: '@media screen and (max-width: 500px)',
  tablet: '@media screen and (max-width: 800px)',
  pc: '@media screen and (max-width: 1024px)',
  wirescreen: '@media screen and (max-width: 1440px)',
}

const theme = {
  max: '1000px',
  color,
  color_level,
  input,
  media,
}

export default theme
